import { Channel, Socket, SocketConnectOption } from 'phoenix';
import { Observable, Observer, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, mapTo } from 'rxjs/operators';

export abstract class WebsocketService {
  public socket: Socket;
  public ready$: Observable<void>;

  private isConnected$: ReplaySubject<Socket> = new ReplaySubject(1);

  constructor() {
    this.ready$ = this.isConnected$.asObservable().pipe(distinctUntilChanged(), mapTo(undefined));
  }

  public updateParams(params: object): void {
    if (this.socket) {
      (<any>this.socket).params = params;
    }
  }

  public subscribeToChannel(topic: string): Observable<Channel> {
    return new Observable((observer: Observer<Channel>) => {
      const channel = this.socket.channel(topic);
      channel.join().receive('error', error => {
        observer.error(
          `Joining the ${topic} channel failed because of following reason: ${error.reason}`,
        );
      });
      observer.next(channel);

      return () => channel.leave();
    });
  }

  protected socketConnect(url: string, options?: Partial<SocketConnectOption>): Socket {
    this.socket = new Socket(url, options);
    this.socket.onOpen(() => this.isConnected$.next(this.socket));
    this.socket.connect();

    return this.socket;
  }
}
